import {Card, Skeleton, Typography} from '@mui/material';
import {Stack} from '@mui/system';
import {Moment} from 'moment';
import {useTranslation} from 'react-i18next';
import {DateChart} from '../../../../../../../../components/charts/date-chart/date-chart';
import {translations} from '../../../../../../../../i18n/translations';
import {useFetchUserHealthData} from './use-fetch-user-health-charts-data';

type SeniorHealthChartsProps = {
  userId: string;
  startDate: Moment;
  endDate: Moment;
};

export function SeniorHealthCharts({userId, endDate, startDate}: SeniorHealthChartsProps) {
  const {t} = useTranslation();

  // --- Fetch data ---
  const data = useFetchUserHealthData({
    userId,
    startDate,
    endDate,
  });

  if (data.fetching) {
    return (
      <Stack gap="20px" flexDirection="row" flexWrap="wrap">
        <ChartSkelly />
        <ChartSkelly />
        <ChartSkelly />
        <ChartSkelly />
        <ChartSkelly />
        <ChartSkelly />
      </Stack>
    );
  }

  if (data.items.length === 0) {
    return (
      <Typography sx={{textAlign: 'center', width: '100%', fontSize: 18}}>
        {t(translations.health_charts.noData)}
      </Typography>
    );
  }

  return (
    <Stack gap="20px" flexDirection="row" flexWrap="wrap">
      {data.items.map((item, idx) => (
        <DateChart key={idx} {...item} />
      ))}
    </Stack>
  );
}

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------

function ChartSkelly() {
  return (
    <Card
      sx={{
        padding: '15px',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '450px',
        maxHeight: '336px',
        width: '100%',
        height: '100%',
      }}
    >
      <Stack height="54vw" gap="20px" alignItems="center">
        <Skeleton variant="rectangular" width="50%" height="18%" animation="wave" />
        <Skeleton variant="rectangular" width="95%" height="74%" animation="wave" />
      </Stack>
    </Card>
  );
}
